export enum CriticalLevel {
  None,
  Warning,
  Critical
}
